import React, { useEffect } from 'react';
import { doc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../firebase';
import './CardTemplate.css';
import Photo from '../images/mokaunited-logo.svg';
import phone from '../images/icons/smartphone-device.svg';
import company from '../images/icons/large-suitcase.svg';
import mail from '../images/icons/mail.svg';
import linkedin from '../images/icons/linkedin.svg';
import website from '../images/icons/www.svg';

const CardTemplate = ({ userData }) => {
    const { id, card_background_color, first_name, last_name, country_code, phone_number, email, website_url, company_name, job_title, linkedin_profile } = userData;
    console.log(userData);
    const fullPhone = country_code && phone_number ? `${country_code}${phone_number}` : phone_number || '';

    // URL ziyaret sayacı
    useEffect(() => {
        const incrementCounter = async () => {
            try {
                const userRef = doc(db, 'users', id);
                await updateDoc(userRef, {
                    urlVisits: increment(1) // 'urlVisits' sayaç alanını güncelle
                });
            } catch (error) {
                console.error('Error incrementing URL visit counter:', error);
            }
        };

        incrementCounter();
    }, [id]); // Bileşen ilk yüklendiğinde çalışır

    useEffect(() => {
        document.body.style.backgroundColor = card_background_color;
    }, [card_background_color]);

    const incrementCounter = async (field) => {
        try {
            const userRef = doc(db, 'users', id);
            await updateDoc(userRef, {
                [field]: increment(1)
            });
        } catch (error) {
            console.error(`Error incrementing ${field}:`, error);
        }
    };

    const handleLinkClick = (url, field) => {
        incrementCounter(field);
        window.open(url.startsWith('http') ? url : `https://${url}`, '_blank', 'noopener,noreferrer');
    };

    const getMobileOperatingSystem = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    };

    const downloadVCard = async () => {
        const vCardData = `
BEGIN:VCARD
VERSION:3.0
N;CHARSET=UTF-8:${last_name || ''};${first_name || ''};;;
FN:${first_name || ''} ${last_name || ''}
${job_title ? `TITLE:${job_title}` : ''}
${fullPhone ? `TEL;TYPE=WORK,VOICE:${fullPhone}` : ''}
${email ? `EMAIL;TYPE=WORK:${email}` : ''}
${company_name ? `ORG:${company_name}` : ''}
${website_url ? `URL:${website_url}` : ''}
${linkedin_profile ? `URL:${linkedin_profile}` : ''}
END:VCARD
        `.trim();

        const blob = new Blob([vCardData], { type: 'text/vcard' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${first_name}_${last_name}.vcf`;
        a.click();
        URL.revokeObjectURL(url);

        // Increment save contact counter
        incrementCounter('saveContactClicks');

        const os = getMobileOperatingSystem();
        if (os === "Android") {
            console.log('vCard file downloaded on Android device. Please manually import the file to your contacts.');
            alert('vCard file downloaded. On Android devices, please manually import the file to your contacts.');
        } else if (os === "iOS") {
            // No additional action needed for iOS, it will open automatically
        }
    };

    return (
        <div className="card-template">
            <div className="card-content">
                <div className="header">
                    <h1>{first_name} {last_name}</h1>
                    <h2>{job_title}</h2>
                </div>
                <div className="info">
                    {phone_number && (
                        <div className='info-sub'>
                            <div className="info-item">
                                <img alt='icons' src={phone} className="icon" size={24} />
                                <div className="info-text">
                                    <p className="info-label">Mobile Phone Number</p>
                                    <a href={`tel:${fullPhone}`} className="info-value">{country_code ? `${country_code} ${phone_number}` : phone_number}</a>
                                </div>
                            </div>
                        </div>
                    )}

                    {email && (
                        <div className='info-sub'>
                            <div className="info-item">
                                <img alt='icons' src={mail} className="icon" size={24} />
                                <div className="info-text">
                                    <p className="info-label">E-Mail Address</p>
                                    <a href={`mailto:${email}`} className="info-value">{email}</a>
                                </div>
                            </div>
                        </div>
                    )}

                    {company_name && (
                        <div className='info-sub'>
                            <div className="info-item">
                                <img alt='icons' src={company} className="icon" size={24} />
                                <div className="info-text">
                                    <p className="info-label">Company</p>
                                    <p className="info-value">{company_name}</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {linkedin_profile && (
                        <div className='info-sub'>
                            <div className="info-item">
                                <img alt='icons' src={linkedin} className="icon" size={24} />
                                <div className="info-text">
                                    <p className="info-label">LinkedIn Address</p>
                                    <button
                                        onClick={() => handleLinkClick(linkedin_profile, 'linkedinClicks')}
                                        className="info-value-link"
                                    >
                                        {linkedin_profile.replace(/^https?:\/\//, '')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {website_url && (
                        <div className='info-sub'>
                            <div className="info-item">
                                <img alt='icons' src={website} className="icon" size={24} />
                                <div className="info-text">
                                    <p className="info-label">Website Address</p>
                                    <button
                                        onClick={() => handleLinkClick(website_url, 'websiteClicks')}
                                        className="info-value-link"
                                    >
                                        {website_url.replace(/^https?:\/\//, '')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="footer">
                    <button onClick={downloadVCard} className="save-button">Save Contact</button>
                    <p>
                        Designed by <a href="https://www.mokaunited.com" target="_blank" rel="noopener noreferrer">
                            <img src={Photo} alt="Moka Logo" className="footer-logo" />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CardTemplate;